import { render, staticRenderFns } from "./PdfFormEdit.vue?vue&type=template&id=bcbf23c4&scoped=true&"
import script from "./PdfFormEdit.vue?vue&type=script&lang=js&"
export * from "./PdfFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./PdfFormEdit.vue?vue&type=style&index=0&id=bcbf23c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbf23c4",
  null
  
)

export default component.exports